import { chakra } from '@stockx/ui';

export const MenuItemsWrapper = chakra('ul', {
  baseStyle: {
    display: { base: 'none', md: 'flex' },
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '90px',
    margin: 0,
    paddingRight: '30px',

    '> li': {
      position: 'relative',
      margin: { base: '0', md: '0 2px', lg: '0 4px' },
      whiteSpace: 'nowrap',
      fontWeight: 500,
      textTransform: 'capitalize',
      listStyle: 'none',

      ' a': {
        padding: { md: '8px 1px', xl: '8px' },
        fontSize: { md: 'xs', lg: 'md' },
        _hover: {
          color: 'inherit',
        },
      },

      '> ul': {
        display: 'none',
      },

      '&:hover': {
        '> ul': {
          display: 'block',
        },
      },

      '#nav-login, #nav-signup': {
        padding: '8px 1rem',
      },

      '#nav-signup': {
        color: 'neutral.white',
      },

      '#nav-login': {
        _hover: {
          color: 'neutral.white',
        },
      },

      '&.sell': {
        margin: { base: '0', md: '0 8px' },
      },
    },
  },
});
